<style scoped>
    .region-selector{
        display: inline-block;
    }
    .hot-region{
        margin-right: 5px;
        margin-bottom: 5px;
    }
</style>
<template>
    <div class="region-selector">
        <Poptip trigger="focus" title="常用国籍/地区" :placement="placement">
            <Input :disabled="disabled" :size="size" placeholder="国籍/地区" :value="value" @on-change="inputChange" icon="ios-pin" />
            <div slot="content">
                <Button size="small"
                        class="hot-region"
                        @click="setRegion(region)"
                        v-for="(region, i) in hot_regions"
                        :key="i">
                    {{region.name}}
                </Button>
                <div class="color-grey">其他国籍/地区请在输入框直接输入</div>
            </div>
        </Poptip>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    export default {
        props: {
            value: {
                type: String
            },
            size: {
                type: String,
                'default': 'small'
            },
            placement: {
                type: String,
                'default': 'bottom'
            },
            disabled: {
                type: Boolean,
                'default': false
            }
        },
        data(){
            return {
                hot_regions: [
                    {
                        name: "中国大陆"
                    },
                    {
                        name: "中国香港"
                    },
                    {
                        name: "中国澳门"
                    },
                    {
                        name: "中国台湾"
                    }
                ]
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            setRegion(region){
                this.$emit('input', region.name);
            },
            inputChange(event){
                this.$emit('input', event.target.value);
            }
        }
    }
</script>
